import PreparePlanAnatomy from '~/pages/anatomy/preparePlan/libs/components/PreparePlanAnatomy'
import { TPageProps } from '~/shared/types/commonTypes'

const PreparePlanAnatomyPage = (props: TPageProps) => (
  <PreparePlanAnatomy {...props} />
)

export default PreparePlanAnatomyPage
